'use strict';
const angular = require('angular');
const {merge, isObject, isString, isUndefined} = angular;

module.exports = [
  DomainUtils];

/** @class */
function DomainUtils() {
}

DomainUtils.prototype.asDomainLink = asDomainLink;
DomainUtils.prototype.getAsLink = getAsLink;
DomainUtils.prototype.serializeUpdate = serializeUpdate;

/**
 *
 * @param {*} domainInstance - Domain class instance
 * @returns {DomainLink}
 * @memberof DomainUtils.prototype
 */
function asDomainLink(domainInstance) {
  return {id: domainInstance.$id, collection: domainInstance.$class.COLLECTION};
}

function getAsLink(data) {
  if (data === null) {
    return null;
  } else if (isUndefined(data)) {
    return null;
  } else if (!isObject(data)) {
    throw new Error('domainUtils.getAsLink expects an object.')
  } else if (data.$class) {
    return asDomainLink(data);
  } else if (isString(data.id) && isString(data.collection)) {
    return {id: data.id, collection: data.collection};
  } else {
    throw new Error('domainUtils.getAsLink expects a valid domain link or instance.')
  }
}

/**
 *
 * @param {string} method
 * @param {Object} data - Domain class instance
 * @param {Object} [options]
 * @memberof DomainUtils.prototype
 */
function serializeUpdate(method, data, options) {
  var request = data.$serialize();
  delete request.dateCreated;
  delete request.lastUpdated;
  delete request.createdBy;
  request.method = method;
  request.id = data.$id;

  if (options)
    merge(request, options);

  return request;
}


// WEBPACK FOOTER //
// ./src/js/core-utilities/domain/DomainUtils.js